/**
 * @Description:  状态组件
 * @author Shi_qshan
 * @date 2021/12/25
 */
import React from "react";
/**
 * @param props
 * @param name: 文本名称
 * @param iconColor: 左侧图标颜色
 * @param fontColor: 右侧文本颜色
 * @returns {JSX.Element}
 * @constructor
 */
const ZkStatus = (props) => {
    const {name, iconColor, fontColor} = props
    return (
        <div className={'zk_status_max'}>
            <div className={'zk_status_left'} style={{background: iconColor}}></div>
            <div className={'zk_status_right'} style={{color: fontColor}}>{name}</div>
        </div>
    )
}

export default ZkStatus